export var UiSidebarMutationTypes;
(function (UiSidebarMutationTypes) {
    UiSidebarMutationTypes["INIT_STATE"] = "INIT_STATE";
    UiSidebarMutationTypes["SET_COLLAPSED"] = "SET_COLLAPSED";
})(UiSidebarMutationTypes || (UiSidebarMutationTypes = {}));
